import React, { createContext, useContext } from "react";
import type { UseScheduleDataReturn } from "./scheduleData";

export const ScheduleContext = createContext<UseScheduleDataReturn | null>(null);

export function useScheduleContext(): UseScheduleDataReturn | null {
  return useContext(ScheduleContext);
}
